import { app } from "../../appGenerator";
import App from "./App.vue";

export const quizVm = app("quiz", App);
